<template>
  <div>
    <el-button class="btn-movil" @click="visibleDrawer()">
      <i class="fas fa-bars"></i>
    </el-button>
    <el-drawer :visible.sync="drawer" direction="ltr" size="60%">
      <div>
        <el-menu
          :default-active="activeLink"
          background-color="#1B1E24"
          text-color="#8B91A0"
          :collapse="false"
          router
        >
          <!-- Menu items -->
          <el-menu-item
            v-for="item in menu"
            :key="item.title"
            :index="item.href ? item.href : 'undefined'"
          >
            <div>
              <i :class="item.icon"></i>
              <span>{{ item.title }}</span>
            </div>
          </el-menu-item>

          <!-- subMenuFieldSite -->
          <el-submenu
            v-for="item in subMenuFieldSite"
            :key="item.title"
            :index="item.href ? item.href : 'undefinded'"
          >
            <template slot="title" class="elMenu">
              <i :class="item.icon"></i>
              <span class="iconSmall">{{ item.title }}</span>
            </template>

            <div v-for="subitem in item.subMenuTwo" :key="subitem.title">
              <el-menu-item :index="subitem.href ? subitem.href : 'undefined'">
                <i :class="subitem.icon"></i>
                {{ subitem.title }}
              </el-menu-item>
            </div>
          </el-submenu>

          <!-- Additional Submenus like subMenuField, subMenuParameters, subMenuConfiguration -->
          <el-submenu
            v-for="item in [subMenuField, subMenuParameters, subMenuConfiguration]"
            :key="item.title"
            :index="item.href ? item.href : 'undefined'"
          >
            <template slot="title" class="elMenu">
              <i :class="item.icon"></i>
              <span class="iconSmall">{{ item.title }}</span>
            </template>

            <div v-for="subitem in item.subMenuTwo" :key="subitem.title">
              <el-menu-item :index="subitem.href ? subitem.href : 'undefined'">
                <i :class="subitem.icon"></i>
                {{ subitem.title }}
              </el-menu-item>
            </div>
          </el-submenu>
        </el-menu>
      </div>
    </el-drawer>
  </div>
</template>



<script>
export default {
  name: "navMenuMobile",
  created: function() {
    var vm = this;
    vm.activeLink = vm.$route.path;
  },
  watch: {
    "$route.path": function() {
      var vm = this;
      vm.activeLink = vm.$route.path;
    }
  },
  components: {},
  props: {
    menu: {
      type: Array,
      required: true
    },
    subMenu: {
      type: Array,
      required: true,
    },
    subMenuFieldSite: {
      type: Array,
      required: false,
    },
    subMenuField: {
      type: Array,
      required: false,
    },
    subMenuParameters: {
      type: Array,
      required: false,
    },
    subMenuConfiguration: {
      type: Array,
      required: false,
    },
  },
  computed: {},
  data() {
    return {
      drawer: false,
      activeLink: ""
    };
  },
  methods: {
    visibleDrawer() {
      this.$emit("clearFilters");
      this.drawer = true;
    },
  }
};


</script>

<style scoped>
.el-menu-item i,
.el-submenu i,
.elMenu i {
  margin-right: 5px;
}
.el-submenu i {
  margin-right: 10px;
}
i {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  align-content: stretch;
}
</style>